/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button } from '@atoms';
import { ArticleField, ArticlesByTagField, ModeSelect } from '@molecules';

import Form from '../Form';

import { FORM_FIELD, TYPE, TYPES } from './constants';

const AddArticleForm = ({ onSubmit }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const [mode, setMode] = React.useState(TYPE.BY_TITLE.value);

  const handleFinish = React.useCallback(
    ({ article }) => {
      onSubmit({
        articleId: article.contentId || article.id,
        articleTitle: article.title,
        articleSlug: article.slug,
        imageId: article.featureImageId,
        imageEdited: article.featureImageEdited,
      });
      form.resetFields();
    },
    [form, onSubmit],
  );

  const handleSelectMode = React.useCallback(
    (_mode) => {
      setMode(_mode);
      form.resetFields([FORM_FIELD.ARTICLE.name]);
    },
    [form],
  );

  return (
    <Form form={form} layout="vertical" onSerializedFinish={handleFinish}>
      <ModeSelect onSelect={handleSelectMode} mode={mode} modes={TYPES} />
      {mode === TYPE.BY_TITLE.value ? (
        <ArticleField {...FORM_FIELD.ARTICLE} isTypeFilter />
      ) : (
        <ArticlesByTagField {...FORM_FIELD.ARTICLE} />
      )}
      <Form.Item>
        <Button type="customBlue" htmlType="submit">
          ADD ARTICLE
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddArticleForm;
